export enum ApplicationLifeStatusFilter {
  activeOnly = 'Active Only',
  deletedOnly = 'Deleted Only',
  all = 'All',
}
